export const POLITICA_DESCONTO_SAVE = "POLITICA_DESCONTO_SAVE";
export const POLITICA_DESCONTO_UPDATE = "POLITICA_DESCONTO_UPDATE";
export const POLITICA_DESCONTO_SAVE_ITENS = "POLITICA_DESCONTO_SAVE_ITENS";
export const POLITICA_DESCONTO_LOAD = "POLITICA_DESCONTO_LOAD";
export const POLITICA_DESCONTO_REMOVE = "POLITICA_DESCONTO_REMOVE";
export const POLITICA_DESCONTO_REMOVE_BULK = "POLITICA_DESCONTO_REMOVE_BULK";
export const POLITICA_DESCONTO_CONFIG = "POLITICA_DESCONTO_CONFIG";
